import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { useStateContext } from "../../../contexts/ContextProvider";
import { Loader, ButtonModifier } from "../../../components";
import { postRequest } from "../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Button } from "@mui/material";
import useScreenWidth from "../../../hooks/useScreenWidth";
import { formatDate } from "../../../constants/helper";

const TampilRevisi = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [noRevisi, setNoRevisi] = useState("");
  const [tipeRevisi, setTipeRevisi] = useState("");
  const [tanggalRevisi, setTanggalRevisi] = useState("");
  const [noRab, setNoRab] = useState("");
  const [tanggalDpRab, setTanggalDpRab] = useState("");
  const [keteranganRevisi, setKeteranganRevisi] = useState("");

  const navigate = useNavigate();
  let isEditableManager = user.tipeUser !== "ADMIN";
  // let isEditable = isEditableManager;
  let isEditable = true;

  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getRevisiById();
  }, []);

  const getRevisiById = async () => {
    setLoading(true);
    const response = await postRequest(
      `/revisis/${id}`,
      {},
      navigate,
      dispatch
    );
    setNoRevisi(response.data.noRevisi);
    setTipeRevisi(response.data.tipeRevisi);
    setTanggalRevisi(formatDate(response.data.tanggalRevisi));
    setNoRab(response.data.rab.noRab);
    setTanggalDpRab(formatDate(response.data.rab.tanggalDpRab));
    setKeteranganRevisi(response.data.keteranganRevisi);
    setLoading(false);
  };

  const deleteRevisi = async (id) => {
    setLoading(true);
    await postRequest(`/deleteRevisi/${id}`, {}, navigate, dispatch);
    navigate("/daftarRevisi");
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Proyek</h3>
      <h5 style={{ fontWeight: 400 }}>Revisi</h5>
      <hr />
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate("/daftarRevisi")}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>
      <Box sx={buttonModifierContainer}>
        {isEditable && (
          <>
            <ButtonModifier
              id={id}
              kode={"test"}
              addLink={null}
              editLink={`/daftarRevisi/revisi/${id}/edit`}
              deleteUser={deleteRevisi}
              nameUser={noRevisi}
            />
          </>
        )}
      </Box>
      <Form>
        <Card>
          <Card.Header>Revisi</Card.Header>
          <Card.Body>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Kode PO :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control required value={noRevisi} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tipe Revisi :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={tipeRevisi}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Revisi :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={tanggalRevisi}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. RAB :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={noRab} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. DP RAB :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={tanggalDpRab} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Keterangan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      as="textarea"
                      rows={4}
                      value={keteranganRevisi}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Form>
    </Container>
  );
};

export default TampilRevisi;

const buttonModifierContainer = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const subTitleText = {
  fontWeight: "900",
};
